import User from "../../assets/download.jpeg"

const TestimonialsSection = () => {
  const testimonials = [
    {
      quote:
        "NYM Technologies transformed our business with their innovative solutions. Their team's expertise and dedication exceeded our expectations.",
      author: "Sarah Johnson",
      position: "CTO, Global Retail Inc.",
      image: User,
    },
    {
      quote:
        "Working with NYM was a game-changer for our digital transformation journey. They delivered on time and within budget.",
      author: "Michael Chen",
      position: "CEO, TechStart Solutions",
      image: User,
    },
    {
      quote:
        "The mobile app NYM developed for us has received outstanding feedback from our users and significantly improved our customer engagement.",
      author: "Emily Rodriguez",
      position: "Product Manager, FinTech Innovations",
      image: User,
    },
  ]

  return (
    <section className="py-20 bg-white relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-blue-50 rounded-full opacity-70 blur-3xl -z-10"></div>
      <div className="absolute bottom-0 right-0 w-64 h-64 bg-blue-50 rounded-full opacity-70 blur-3xl -z-10"></div>

      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 mb-3">
            <div className="h-px w-10 bg-gradient-to-r from-blue-400 to-blue-600"></div>
            <span className="text-sm font-medium text-blue-600 uppercase tracking-wider">Client Feedback</span>
            <div className="h-px w-10 bg-gradient-to-r from-blue-600 to-blue-400"></div>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">What Our Clients Say</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Don't just take our word for it. Here's what our clients have to say about working with us.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 relative">
              {/* Quote mark */}
              <div className="absolute -top-4 -left-4 w-8 h-8 bg-gradient-to-r from-blue-400 to-blue-600 rounded-full flex items-center justify-center text-white">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 11l-5 5m0 0l5 5m-5-5h12" />
                </svg>
              </div>

              <div className="mb-6 text-gray-700 italic">"{testimonial.quote}"</div>

              <div className="flex items-center">
                <img
                  src={testimonial.image || "/placeholder.svg"}
                  alt={testimonial.author}
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <h4 className="font-bold text-gray-900">{testimonial.author}</h4>
                  {/* <p className="text-sm text-gray-600">{testimonial.position}</p> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default TestimonialsSection
